import _ from 'lodash';
import {
  CUSTOM_FIELDS_KEY,
  FilterTypesWithoutFields,
  ISSUE_STATES_INFO_TEXTS
} from './EditCustomPmMetricsModal.constants';
import { FILTER_TYPES } from 'common/constants/filters';
import { PM_PROVIDERS } from 'common/constants/constants';

export const SECTIONS_KEYS = {
  [PM_PROVIDERS.JIRA]: {
    ISSUE_STATE: 'JIRA STATE',
    ISSUE_TYPE: 'ISSUE TYPE'
  },
  [PM_PROVIDERS.AZURE_BOARDS]: {
    ISSUE_STATE: 'AZURE STATE',
    ISSUE_TYPE: 'WORK ITEM'
  }
};

export const formatFiltersFromDB = ({
  allBoards,
  orgTeams,
  filters,
  issueTypes
}) => {
  const currLabels = (filters?.labels || []).map(({ name }) => ({
    id: name,
    title: name
  }));

  const currTeams = orgTeams
    ?.filter(({ id }) => {
      return _.get(filters, 'team_ids', [])
        .map(id => parseInt(id))
        .includes(id);
    })
    .map(({ id, name, color }) => ({
      id,
      title: name,
      color
    }));

  const currBoards = _.at(
    allBoards,
    _.get(filters, 'boards', []).map(({ provider_id }) => provider_id)
  )
    .filter(value => value !== undefined)
    .map(({ provider_id, name, color }) => ({
      id: provider_id,
      title: name,
      name
    }));

  const selectedIssueTypes = _.get(filters, 'issue_types', []).map(
    ({ name }) => name
  );

  const currIssueTypes = Object.values(issueTypes)
    .filter(({ name }) => {
      return selectedIssueTypes.includes(name);
    })
    .map(({ id, name }) => ({
      id,
      title: name,
      name
    }));

  return {
    [FILTER_TYPES.BOARD]: currBoards,
    [FILTER_TYPES.EPIC]: _.get(filters, 'epics', []),
    [FILTER_TYPES.LABEL]: currLabels,
    [FILTER_TYPES.FIELD]: _.get(filters, CUSTOM_FIELDS_KEY, []),
    [FILTER_TYPES.ORGANIZATION_TEAMS]: currTeams,
    issue_types: currIssueTypes,
    state_transitions: _.get(filters, 'state_transitions', [])
  };
};

const customFieldValueFormatter = data =>
  _.map(data, value => ({
    id: value,
    key: value,
    title: value
  }));

export const formatCustomField = data => {
  const customFields = data.reduce((acc, { id, value }) => {
    return {
      ...acc,
      [id]: customFieldValueFormatter(value)
    };
  }, {});
  return customFields;
};

export const formatFiltersToDB = {
  boards: data =>
    _.map(data, ({ id, title }) => ({
      provider_id: id,
      title
    })),
  epics: data =>
    _.map(data, epic => ({
      ...epic,
      provider_id: _.get(epic, 'id'),
      key: _.get(epic, 'key') || _.get(epic, 'title')
    })),
  labels: data =>
    _.map(data, ({ title }) => ({
      name: title
    })),
  team_ids: data => _.map(data, ({ id }) => Number(id)),
  issue_types: data => _.map(data, ({ title }) => ({ name: title })),
  issue_state: data =>
    _.map(data, ({ title, category }) => ({ name: title, category })),
  field: data => {
    let i = 0;
    return _.map(data, field => ({
      id: Object.keys(data)[i++],
      value: _.map(field, ({ id }) => id)
    }));
  }
};

export const getIssueStateInfoText = currentFilters => {
  const selectedStateCategory = _.get(
    currentFilters,
    'issue_states[0].category'
  );
  return _.get(ISSUE_STATES_INFO_TEXTS, selectedStateCategory);
};

export const getCustomFieldsFromFilters = filters => {
  return _.omit(filters, FilterTypesWithoutFields);
};

export const isNewFiltersAddedToWidget = (
  newFilters,
  widgetFilters,
  filterType
) => {
  const newEntitities = newFilters[filterType] || [];
  const widgetEntities = widgetFilters[filterType] || [];
  const allIncluded = newEntitities.every(newItem =>
    widgetEntities.some(widgetItem => widgetItem.id === newItem.id)
  );
  return !allIncluded;
};
